<template>
  <div class="show" v-if="showInfo">
    
    <div class="box">
      <div class="logo">
          <img :src="`${IP_TEST}/uploads/${logopic}`" alt="" @click="$router.push('/')">
        </div>
      <div class="content">
        <div class="headerinfo">
          <h2>
            个人信息
          </h2>
          <a href="javascript:;;" @click="download()" class="back" v-if="$route.query.comeinbysy!='1'&&!showInfo.honoraryTitle" >下载电子证书</a><a class="back" href="/">返回主页</a>
          <div class="compytitle">
            <img :src="`${IP_TEST}/uploads/xlsfile/usepic/${showInfo.picsrc}`" :alt="showInfo.name">
            <div class="info">
              <h3>
                {{ showInfo.name }}
              </h3>
              <p>
               性别：{{ showInfo.sex }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;所在地：{{ showInfo.country }}
              </p>
              <p>
               所属行业：{{ showInfo.industry }}
              </p>
              <p>
                办公地址：{{ showInfo.address }}
              </p>
            </div>
            
          </div>
        </div>
        <div class="codeinfo">
          <img src="/static/img/huiayun.png" alt="">
          <span v-if="showInfo.honoraryTitle" style="margin-right:30px;">荣誉称号：{{ showInfo.honoraryTitle }}</span>  
         
          <span v-if="showInfo.honoraryTitle" >荣誉编号：{{ showInfo.code }}</span>
          <span v-else >会员编号：{{ showInfo.code }}</span>
        </div>
        <div class="detailInfo">
          <table>
            <tr>
              <th colspan="2">个人简历</th>
            </tr>
            <tr>
              <td colspan="2" v-html="showInfo.description" ></td>
            </tr>
            <tr>
              <td style="width: 150px;">
                会员有效期
              </td>
              <td>
                {{ formatExcelData(showInfo.certdate) }}至{{ formatExcelData(showInfo.valieddate) }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
/**
 * 企业证书查询系统模版
 */
import { IP_TEST } from '@/config';
import QRCode from "qrcodejs2";
export default {
  name: "ShowQy",
  data() {
    return {
      IP_TEST
    }
  },
  computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  props: {
    showInfo: Object
  },
  mounted() {
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    download() {
      this.$axios
        .get(`${IP_TEST}/uploads/证书图下载/${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.name}.jpg`, {
          responseType: "blob", //重要
        })
        .then((response) => {
          if ("msSaveOrOpenBlob" in window.navigator) {
            //兼容ie浏览器下载报传递给系统调用的数据区域太小.
            var data = response;
            var blob = new Blob([data], { type: "application/vnd.ms-excel" });
            window.navigator.msSaveOrOpenBlob(blob, `${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.name}.jpg`);
            return;
          } else {
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS&&!this.isWeixinBrowser()) {
              var jpeg = new Blob([response], { type: "image/jpeg" });
              const url = window.URL.createObjectURL(jpeg);
              const link = document.createElement("a");
              let fname = `${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.name}.jpg`;
              link.href = url;
              link.setAttribute("download", fname);
              link.download = fname;
              document.body.appendChild(link);
              link.click();
              return;
            }
            else if(isiOS&&this.isWeixinBrowser())
            {
              var winHeight = $(window).height();
              $(".weixin-tip").css("height",winHeight);
              $(".weixin-tip").show();
              return;
            }
            window.open(
              `${IP_TEST}/qynlw/loadimgs?imgpath=证书图下载/${this.showInfo.code.replace(/\//g,'_')}_${this.showInfo.name}.jpg`,
              "_blank"
            );
          }
        });
    },
    isWeixinBrowser() {
      return /micromessenger/.test(navigator.userAgent.toLowerCase())
        ? true
        : false;
    },
    isQQBrowser() {
      return /qq/.test(navigator.userAgent.toLowerCase()) ? true : false;
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
    },
    formatExcel(value) {
        if (!value) {
            return "";
        } else {
            if (typeof value == "string") {
                return value.trim();
            } else {
                return value.toString().trim();
            }
        }
    }
  }
};
</script>
<style scoped>
.show{
  position: relative;
  width: 100%;
  min-height: 1213px;
    background-image: url(/static/img/wbt.png);
    background-size: cover;
    padding-bottom: 71px;
}
.show .box{
  width: 1300px;
  margin: auto;
  position: relative;
  top:47px;
}
.content .headerinfo{
  height: 387px;
  margin-top:65px;
  background: rgba(21, 0, 125, 0.3);
}
.content .headerinfo h2{
  background-image: url(/static/img/baiotiti.png);
    background-repeat: no-repeat;
    background-size: contain;
    height: 92px;
    width: 465px;
    margin: auto;
    position: relative;
    top: 50px;
    font-size: 32px;
    text-align: center;
    line-height: 92px;
    /* font-weight: bold; */
    color: #FFFFFF;
}
.compytitle{
  height: 171px;
  width:auto;
  /* padding-left: 140px; */
  margin-top: 95px;
  position: relative;
  left: 41px;
  border-radius: 5px;
}
.compytitle img{
  width: 125px;
}
.compytitle .info{
  width:1075px;
  display: inline-block;
  margin-left: 39px;
}
.compytitle h3{
    font-size: 28px;
  /* font-weight: bold; */
  color: #FFFFFF;
  letter-spacing: 4px;
}
.compytitle p{
  color: #cdccd8;
    font-size: 21px;
    font-weight: 400;
    letter-spacing: 3px;
    margin-top: 13px;
    border-bottom: 1px dotted;
    line-height: 33px;
}
.codeinfo{
  margin-top: 3px;
  width: 1300px;
  height: 65px;
  background: rgba(21, 0, 125, 0.3);
  line-height: 65px;
  font-size: 24px;
  color: #FFFFFF;
  letter-spacing: 3px;
  border-radius: 5px;
}
.codeinfo img{
  margin-left: 48px;
  margin-right: 12px;
  position: relative;

    top: 19px;
}
.detailInfo{
  margin-top:26px;
  width: 1266px;
  min-height: 255px;
  background: rgba(21, 0, 125, 0.3);
  padding: 12px 17px 28px 17px;
  border-radius: 5px;
}

.detailInfo td{
  border:1px solid RGBA(7, 84, 185, 1);
  /* padding:5px 15px; */
  min-height: 54px;
  height: 54px;
  padding-left: 32px;
  font-size: 21px;
  line-height: 33px;
}
.detailInfo th{
  /* background: #DDEBFC; */
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  height: 62px;
  line-height: 62px;
  border: 1px solid #0157C6;
  color: #fff;
  font-size:24px;
  letter-spacing: 4px;
}
.detailInfo tr td{
  font-size: 18px;
color: #FFFFFF;
  width: 1266px;
}
.headerinfo .back{
  color: #fff;
    float: right;
    margin-top: -12px;
    margin-right: 20px;
    font-size: 16px;
    border-bottom: solid 1px;
    line-height: 25px;
}
</style>